<div class="dealer-list">
  @for (dealer of dealers; track dealer; let i = $index) {
    <div class="dealer">
      <div class="dealer-details">
        @if (dealer != undefined) {
          <div class="dealer-profile">
            <!-- <h6>Id: <b>{{dealer.username}}</b></h6> -->
            <h6>Nom: <b> {{dealer.civility}} {{dealer.firstName}}, {{dealer.lastName}}</b>, Type: <b>{{dealer.dealerType}}</b></h6>
            <h6>Statut: <b>{{dealer.status}}</b></h6>
            <h6>Fournisseurs préférés:
              @for (prov of dealer.favoriteProviderIds; track prov; let i = $index) {
                <b>
                  <a [routerLink]="['/provider-public']" [queryParams]="{id: prov}"> {{prov}}</a>,&nbsp;
                </b>
              }
            </h6>
            <h6>
              <label>Avis clients: </label>
              @for (r of dealer.ratingsSummary.indicators; track r; let i = $index) {
                <span>
                  @if (r===1) {
                    <mat-icon>star</mat-icon>
                  }
                  @if (r!==1) {
                    <mat-icon> {{r===0?'star_outlined':'star_half'}}</mat-icon>
                  }
                </span>
              }
              <b>{{ dealer.ratingsSummary.average.toFixed(2)}} </b>
              <mat-icon (click)="showDetails = !showDetails" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayOpen]="showDetails">
                <div class="ratings-details">
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{dealer.ratingsSummary.counts[4]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[3]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[2]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[1]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{dealer.ratingsSummary.counts[0]}})</h6>
                </div>
              </ng-template>
              ({{ getRatingsTotalCount(i)}} avis)
            </h6>
            <h6>Lieu de résidence: {{dealer.cityResident}}, {{getCountryByCode(dealer.countryResident).name}}
              &nbsp;
              <span class = "mini-flag">
                <img  mat-card-image src="assets/images/country-flags/{{dealer.countryResident}}.png" alt="{{dealer.countryResident}}">
              </span>
            </h6>
            <h6>Email: {{dealer.email}}, Telephone:  +{{dealer.phoneNumber.code}}&nbsp;{{dealer.phoneNumber.number}}</h6>
            <h6>Entreprise: {{dealer.businessName}}, {{dealer.businessType}}, Membre dépuis: {{dateFormat(dealer.created)}}</h6>
            <h6> Titre: {{dealer.keepOffer.offerTitle}}</h6>
            <h6> Description: {{dealer.keepOffer.offerDescription}}</h6>
            <h6>Services fournis: @for (serv of dealer.keepOffer.servicesProvided; track serv; let i = $index) {
              <b>{{getServiceTypeTitle(serv)}},&nbsp;</b>
            }</h6>
            <h6>Spécialités (marques): @for (mk of dealer.keepOffer.specialtyMakes; track mk; let i = $index) {
              <b>{{mk}},&nbsp;</b>
            }</h6>
            <h6>Catégories prestations: @for (cat of dealer.keepOffer.jobCategories; track cat; let i = $index) {
              <b>{{getCategoryTitle(cat)}},&nbsp;</b>
            }</h6>
            <h6>Localisation: <b>{{dealer.keepOffer.geoLocation?.latitude}}, {{dealer.keepOffer.geoLocation?.longitude}}</b></h6>
          </div>
        }
        <div class="dealer-buttons">
          @if ((dealer.status === DealerStatus.AWAITING_VERIFICATION || dealer.status === DealerStatus.SUSPENDED)) {
            <button
              class="cta-button-keep"  mat-button (click)="openJobDialog(dealer.keepOffer.offerId, '');$event.stopPropagation()">
              Prendre rdv <mat-icon>favorite_outline</mat-icon>
            </button>
          }
          @if ((dealer.status === DealerStatus.AWAITING_VERIFICATION || dealer.status === DealerStatus.SUSPENDED)) {
            <button
              class="simple-button-keep"  mat-button (click)="toggleFavoriteProvider(dealer.username);$event.stopPropagation()">
              Ajouter favori <mat-icon>favorite_outline</mat-icon>
            </button>
          }
          <button
            class="simple-button-keep"  mat-button [routerLink]="['/provider-public']" [queryParams]="{id: dealer.username}">
            Profil <mat-icon>open_in_new</mat-icon>
          </button>
          @if ((dealer.status === DealerStatus.AWAITING_VERIFICATION || dealer.status === DealerStatus.SUSPENDED)) {
            <button
              class="cta-button-keep"  mat-button (click)="updateDealerStatus(dealer.username, DealerStatus.ACTIVE);$event.stopPropagation()">
              Activer <mat-icon>check</mat-icon>
            </button>
          }
          @if ((dealer.status === DealerStatus.ACTIVE)) {
            <button
              class="simple-button-keep"  mat-button (click)="updateDealerStatus(dealer.username, DealerStatus.SUSPENDED);$event.stopPropagation()">
              Suspendre <mat-icon>accept</mat-icon>
            </button>
          }
          <!-- <a [routerLink]="['/provider-public']" [queryParams]="{id: dealer.username}"> Profil public</a>,&nbsp; -->
        </div>
      </div>
      <div class="dealer-contracts">
        <mat-accordion multi>
          @if (dealer.jobs != undefined) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <h4>Jobs <span>({{dealer.jobs.length}}) </span></h4>
                  <button class="simple-button" mat-button (click)="openJobDialog(dealer.keepOffer.offerId, '');$event.stopPropagation()">
                    <mat-icon>add</mat-icon>Nouvelle
                  </button>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if ((dealer.jobs.length >= 0)) {
                <app-jobs
                  [objectSource]="objectSource"
                  [offerId] = "dealer.keepOffer.offerId"
                  [enableNew]="false"
                  >
                </app-jobs>
              }
            </mat-expansion-panel>
          }
          <!--
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h4>Contrats client <span *ngIf="dealer.customerContracts.length >= 0">({{dealer.customerContracts.length}}) </span></h4>
                <button class="simple-button-keep" mat-button (click)="openNewContractDialog(dealer.username);$event.stopPropagation()">
                  <mat-icon>add</mat-icon>Nouveau
                </button>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-contracts
              *ngIf="(dealer.customerContracts.length >= 0)"
              [objectSource]="objectSource"
              [transactionRole]="TransactionRole.CUSTOMER"
              [dealerId]="dealer.username"
              [enableNew]="false">
            </app-contracts>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h4>Contrats provider <span *ngIf="dealer.providerContracts.length >= 0">({{dealer.providerContracts.length}}) </span></h4>
                <button class="simple-button-keep" mat-button (click)="openNewContractDialog(dealer.username);$event.stopPropagation()">
                  <mat-icon>add</mat-icon>Nouveau
                </button>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-contracts
              *ngIf="(dealer.providerContracts.length >= 0)"
              [objectSource]="objectSource"
              [transactionRole]="TransactionRole.PROVIDER"
              [dealerId]="dealer.username"
              [enableNew]="false">
            </app-contracts>
          </mat-expansion-panel>
          -->
        </mat-accordion>
      </div>
    </div>
  }
</div>
